import { Sliders, ChartBar } from "@phosphor-icons/react";

// Panel lateral que en escritorio es columna fija y en móvil es un bottom-sheet deslizable.
export function Sheet({ open, side, testid, className = "", children }) {
  const mobile = `fixed inset-x-0 bottom-0 z-[1200] max-h-[74vh] rounded-t-2xl border-t border-[#e5e7eb] shadow-[0_-8px_30px_rgba(0,0,0,0.22)] transition-transform duration-300 ease-out ${open ? "translate-y-0" : "translate-y-[110%] pointer-events-none"}`;
  const desktop = `lg:static lg:inset-auto lg:bottom-auto lg:z-auto lg:max-h-none lg:rounded-none lg:shadow-none lg:translate-y-0 lg:pointer-events-auto lg:shrink-0 lg:border-t-0 ${side === "left" ? "lg:border-r" : "lg:border-l"}`;
  return (
    <aside data-testid={testid} className={`bg-white overflow-y-auto p-4 ${mobile} ${desktop} ${className}`}>
      <div className="lg:hidden w-9 h-1 rounded-full bg-[#cbd5e1] mx-auto mb-3" />
      {children}
    </aside>
  );
}

// Botones flotantes (solo móvil) para abrir/cerrar los paneles + fondo oscuro.
export function SheetToggles({ sheet, setSheet, controlsLabel = "Controles", dataLabel = "Datos" }) {
  const base = "flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold shadow-lg border transition-colors";
  return (
    <>
      {sheet && (
        <div className="lg:hidden fixed inset-0 bg-black/30 z-[1150]" onClick={() => setSheet(null)} data-testid="sheet-backdrop" />
      )}
      <div className="lg:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-[1300] flex gap-2">
        <button data-testid="sheet-toggle-controls" onClick={() => setSheet((s) => (s === "controls" ? null : "controls"))}
          className={`${base} ${sheet === "controls" ? "bg-[#3f8e33] text-white border-[#3f8e33]" : "bg-white text-[#1a2318] border-[#e5e7eb]"}`}>
          <Sliders size={16} /> {controlsLabel}
        </button>
        <button data-testid="sheet-toggle-data" onClick={() => setSheet((s) => (s === "data" ? null : "data"))}
          className={`${base} ${sheet === "data" ? "bg-[#3f8e33] text-white border-[#3f8e33]" : "bg-white text-[#1a2318] border-[#e5e7eb]"}`}>
          <ChartBar size={16} /> {dataLabel}
        </button>
      </div>
    </>
  );
}
